import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAllItemsInCheckout } from '../../features/checkout/checkoutSlice';
import Cart from './Cart';
import Invoice from './Invoice';
import Payment from './Payment';

const Summary = () => {
    const { cartProducts, cartTotalAmount } = useSelector((state) => state.cartProducts)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setAllItemsInCheckout({cartProducts, cartTotalAmount}))
    }, [dispatch, cartProducts, cartTotalAmount]);

    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);
    
    return (
        <div className="px-2 md:px-14 lg:px-32 border-2 bg-white p-3">
            <h3 className='pt-2 pb-3 font-poppins text-2xl text-gray-600'>{translate ? "Order Summary - Payment" : "অর্ডার সারাংশ - পেমেন্ট"}</h3>
            <div className="grid grid-cols-4 gap-8">
                <div className="col-span-4 lg:col-span-1 border border-gray-100 p-3">
                    <Invoice/>
                </div>
                <div className="col-span-4 lg:col-span-1 border border-gray-100 p-3">
                    <Payment/>
                </div>
                <div className="col-span-4 lg:col-span-2 border border-gray-100 p-2">
                    <Cart/>
                </div>
            </div>
        </div>
    );
};

export default Summary;